function getDeviceInfo() {
  // UNUSED
}

export default getDeviceInfo;
